import {Moment} from "moment";

export class InventoryPlans {
    deleted: boolean;
    deliveryNoteCode: string;
    deliveryNoteId: string;
    hqPackingList: HqPackingList[];
    id: string;
    state: string;
    storageLayerNames: string;
}

export class InventoryPlansNew {
    abbreviation: string;
    completedDate: string;
    createdAt: string;
    deliveryNoteCode: string;
    deliveryNoteId: string;
    id: string;
    state: string;
    storageLayerNames: string;
}

export class HqPackingList {
    canCreateDeliveryTime: string;
    canUpdateDeliveryTime: string;
    code: string;
    createdAt: string;
    customsPackingProblemQuantity: string;
    customsPackingQuantity: string;
    customsPackingSet: CustomsPackingSet[];
    deliveryEndTime: string;
    deliveryStartTime: string;
    factoryDeliveryNoteId: string;
    factoryName: string;
    id: string;
    parentCode: string;
    purchaserName: string;
    receiveListId: string;
    remark: string;
    unpackedProductInfos: UnpackedProductInfos[];
    uploadDate: string;
    warehouseReceiptId: string;
    state: HqState;
    inventoryState: InventoryState;
    inventoryAckState: InventoryAckState;
}

export class UnpackedProductInfos {
    isEdit: boolean;
    createdAt: string;
    declarationDescription: string;
    description: string;
    guestModel: string;
    hqOrJrNumber: string;
    id: string;
    loadingFirst: string;
    netWeight: number;
    oeNumber: string;
    packingNumberPcs: number;
    parentId: string;
    poNumber: string;
    problemType: string;
    purchaseOrderNumber: string;
    refNumber: string;
    remark: string;
    totalNetWeight: string;
    totalNumberPcs: number;
    originTotalPcs: number;
    totalPcs: number;
    type: string;
    unitPrice: number;
}

export class CustomsPackingSet {
    id: string;
    code: CustomsCode;
    declarationDescriptions: string;
    descriptions: string;
    factoryName: string;
    hqPackingListCode: string;
    hqPackingListId: string;
    packingVolume: PackingVolume;
    packingWeight: PackingWeight;
    problemType: ProblemType;
    productQuantity: number;
    purchaseOrderNumbers: string;
    remark: string;
    secondaryPackingQuantity: string;
    secondaryPackingResponses: string;
    secondaryPackingSet: string;
    state: CustomsPackingState;
    inventoryState: InventoryState;
    inventoryAckState: InventoryAckState;
    choice: boolean;
    isEdit: boolean;
}

export class CustomsCode {
    selfCode: string;
    serialNumber: string;
    typeCode: string;
}

export class PackingVolume {
    height: number;
    length: number;
    width: number;
}

export class PackingWeight {
    grossWeight: number;
    netWeight: number;
}

export class HqState {
    canDeclared: boolean;
    desc: string;
    name: string;
}

export class ProblemType {
    name: string;
    desc: string;
}

export class CustomsPackingState {
    name: string;
    desc: string;
}

export class InventoryState {
    name: string;
    desc: string;
}

export class InventoryAckState {
    name: string;
    desc: string;
}
